var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "result-search-page" } }, [
    _c("div", { staticClass: "container full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "search-result-top" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "bottom space-between" }, [
            _c("div", { staticClass: "left" }, [
              _vm.total > 0
                ? _c("span", { staticClass: "showing" }, [
                    _c("strong", [_vm._v("Showing")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.from))]),
                    _vm._v("-"),
                    _c("span", [_vm._v(_vm._s(_vm.to))]),
                    _vm._v(" of "),
                    _c("span", [_vm._v(_vm._s(_vm.total))]),
                    _vm._v(
                      "\n                            results\n                        "
                    )
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-table" },
          [
            _c("b-table", {
              staticClass: "list-table",
              attrs: {
                "sort-by": _vm.sort_by,
                "sort-desc": _vm.sort_desc,
                fields: _vm.fields,
                items: _vm.requests.map(function(item) {
                  item._showDetails = true
                  return item
                }),
                "show-empty": ""
              },
              on: {
                "update:sortBy": function($event) {
                  _vm.sort_by = $event
                },
                "update:sort-by": function($event) {
                  _vm.sort_by = $event
                },
                "update:sortDesc": function($event) {
                  _vm.sort_desc = $event
                },
                "update:sort-desc": function($event) {
                  _vm.sort_desc = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                        No data is available...\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(image)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.$laravelRoute(
                              "vehicle-stock-request.show",
                              data.item.id
                            )
                          }
                        },
                        [
                          data.item.vehicle_stock.front_image_url
                            ? _c("img", {
                                attrs: {
                                  src: data.item.vehicle_stock.front_image_url,
                                  alt: "Front"
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    ]
                  }
                },
                {
                  key: "cell(vehicle)",
                  fn: function(data) {
                    return [
                      data.item.vehicle_stock
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/vehicle-stock/" + data.item.vehicle_stock.id
                              }
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.vehicle_stock.year) +
                                  "\n                            " +
                                  _vm._s(data.item.vehicle_stock.make) +
                                  "\n                            " +
                                  _vm._s(data.item.vehicle_stock.model) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(first_name)",
                  fn: function(data) {
                    return [
                      data.item.user_id
                        ? _c(
                            "a",
                            { attrs: { href: "/users/" + data.item.user_id } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(data.item.first_name) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(data.item.first_name))])
                    ]
                  }
                },
                {
                  key: "cell(actions)",
                  fn: function(data) {
                    return [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.$laravelRoute(
                              "vehicle-stock.show",
                              data.item.id
                            )
                          }
                        },
                        [_vm._v("View")]
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "bottom-container-result d-flex justify-content-end flex-wrap"
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _vm.total > 0
                      ? _c("b-pagination", {
                          attrs: {
                            "total-rows": _vm.total,
                            "per-page": _vm.per_page
                          },
                          model: {
                            value: _vm.current_page,
                            callback: function($$v) {
                              _vm.current_page = $$v
                            },
                            expression: "current_page"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "left" }, [
        _c("h2", [
          _vm._v(
            "\n                            SBL Stock Requests\n                        "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42baa1ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42baa1ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/RequestsListPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-42baa1ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/RequestsListPage.vue
// module chunks = 0